import React from "react";

function RateRender({ data, styles }) {
  const RateRender = rate => {
    let JSX = [];
    let newRate = 5;
    if (rate) {
      newRate = Math.floor(rate);
    }
    for (let index = 1; index <= 5; index++) {
      if (index > newRate) {
        JSX.push(<i key={index} className="fa fa-star" />);
      } else {
        JSX.push(<i key={index} className="fa fa-star text-warning" />);
      }
    }
    return JSX;
  };
  return <div style={{ ...styles }}>{RateRender(data)}</div>;
}

export default RateRender;
